
import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Home, ArrowLeft } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

const NotFound = () => {
  const location = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-uplivion-lightBlue bg-opacity-20">
      <div className="text-center max-w-md mx-auto p-8">
        <div className="mb-8">
          <h1 className="text-6xl font-bold text-uplivion-blue mb-4">404</h1>
          <h2 className="text-2xl font-semibold text-gray-800 mb-2">Seite nicht gefunden</h2>
          <p className="text-gray-600 mb-8">
            Die Seite, die du suchst, existiert nicht oder wurde verschoben.
          </p>
        </div>
        
        <div className="space-y-4">
          {user ? (
            <Button asChild className="w-full bg-uplivion-blue hover:bg-uplivion-blue/90">
              <Link to="/dashboard" className="flex items-center justify-center gap-2">
                <Home className="h-4 w-4" />
                Zurück zum Dashboard
              </Link>
            </Button>
          ) : (
            <Button asChild className="w-full bg-uplivion-blue hover:bg-uplivion-blue/90">
              <Link to="/" className="flex items-center justify-center gap-2">
                <Home className="h-4 w-4" />
                Zur Startseite
              </Link>
            </Button>
          )}
          
          <Button 
            variant="outline" 
            onClick={() => window.history.back()} 
            className="w-full border-uplivion-blue text-uplivion-blue hover:bg-uplivion-blue hover:text-white"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Zurück
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
